import React from 'react';
import classnames from 'classnames';

// Types
import { DirectionType } from './WpSteps';

// Components
import WpIcon from '../icon/WpIcon';

// Styles
import './WpStep.scss';

type Props = {
  title: string;
  stepNumber?: number;
  active?: boolean;
  completed?: boolean;
  disabled?: boolean;
  direction?: DirectionType;
  onClick?: () => void;
};

const WpStep = ({ title, stepNumber, active, completed, disabled = false, direction, onClick }: Props) => {
  const baseClassName = 'WpStep-v2';
  const classes = classnames(
    baseClassName,
    `${baseClassName}--${direction}`,
    active && `${baseClassName}--active`,
    completed && `${baseClassName}--completed`,
    disabled && `${baseClassName}--disabled`,
    onClick && `${baseClassName}--pointer`
  );

  return (
    <div
      className={classes}
      onClick={!disabled && onClick}
      onKeyDown={!disabled && onClick}
      role="tab"
      tabIndex={0}
      aria-selected={active}
    >
      <div className={`${baseClassName}__number-wrapper`}>
        <div className={`${baseClassName}__number`}>{completed ? <WpIcon name="check" /> : stepNumber}</div>
        <div className={`${baseClassName}__title`}>{title}</div>
      </div>
    </div>
  );
};

export default WpStep;
